import { Divider, Row, Select } from 'antd'
import { useAppSelector } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import { currencyListSelector } from 'src/features'
import React, { useState, useEffect } from 'react'
import { Currency, Deposit } from 'src/core/models'
import styles from './DepositsDetailsModal.module.scss'
import { CustomModal, CustomText, CustomCol, CustomTitle } from 'src/components'
import { getBankAccount } from './DepositDetailsModalContent/deposit-content.helpers'
import DepositDetailsModalContent from './DepositDetailsModalContent/DepositDetailsModalContent'

interface DepositsDetailsModalProps {
  isModalVisible: boolean,
  handleCancel: () => void,
  deposit: Deposit
  showHeaderLabel?: boolean
  modalTitle?: string
  footerContent?: React.ReactNode
}

const DepositsDetailsModal: React.FC<DepositsDetailsModalProps> = (props) => {
  const { t } = useTranslation()
  const {
    isModalVisible, handleCancel, deposit,
    modalTitle = deposit?.kind === 'bank' ? t('Deposits.ModalTitle') : t('Summary.Deposit'),
    showHeaderLabel = deposit?.kind === 'bank',
    footerContent = null
  } = props
  const showBankDetails = deposit?.kind === 'bank'
  const currencyList = useAppSelector(currencyListSelector)
  const code = currencyList?.find((c: Currency) => c.id === deposit?.currency_token_id)?.code
  const [selectedCountry, setSelectedCountry] = useState<'USA' | 'SPAIN'>(code === 'USD' ? 'USA' : 'SPAIN')
  const { fileUrl, beneficiaryName } = getBankAccount(code, selectedCountry)

  useEffect(() => { if (code === 'USD') {setSelectedCountry('USA')} }, [code])

  return (
    <CustomModal
      title={modalTitle}
      footer={null}
      open={isModalVisible}
      onCancel={handleCancel}
    >
      {/* Header */}
      {showHeaderLabel && <CustomText label={t('Deposits.ModalHeader')}/>}
      {/* Bank country Selector */}
      {showBankDetails &&
        <>
          <Row className={styles.bankAccount}>
            <CustomCol>
              <CustomTitle label={t('Deposits.BankAccount.Title')} type={null}/>
            </CustomCol>
            <CustomCol>
              <Select
                value={selectedCountry}
                onChange={(value) => setSelectedCountry(value)}
                className={styles.bankAccountSelector}
                disabled={code !== 'USD'}
              >
                {code === 'USD' && <Select.Option value={'USA'}>{t('Deposits.BankAccount.USA')}</Select.Option>}
                <Select.Option value={'SPAIN'}>{t('Deposits.BankAccount.SPAIN')}</Select.Option>
              </Select>
            </CustomCol>
          </Row>
          <Divider/>
        </>
      }
      {/* Content */}
      <DepositDetailsModalContent
        selectedCountry={selectedCountry}
        deposit={deposit}
        code={code}
      />
      {showBankDetails &&
        <>
          {/* Footer */}
          <Divider/>
          <span dangerouslySetInnerHTML={{
            __html: t('Deposits.ClickToDownloadBankCertificate',
              { fileUrl, beneficiaryName })
          }}/>
        </>
      }
      {/* More Content */}
      {footerContent}
    </CustomModal>
  )
}

export default DepositsDetailsModal
